module.exports = __webpack_public_path__ + "img/disable.ce8acfe4.svg";